import { z } from 'zod/v4';
import {
  buildEntityHistoryEntrySchema,
  buildEntityHistoryListResponseSchema,
  CompanyProfileHistoryMetadataSchema,
  EntityHistoryListQuerySchema,
} from '../../../entity-history/contracts/index.js';

export const CompanyProfileHistoryParamsSchema = z.object({
  /** The company whose profile history is read — `for_company_id`. */
  id: z.string(),
});

export type CompanyProfileHistoryParams = z.infer<
  typeof CompanyProfileHistoryParamsSchema
>;

export const CompanyProfileHistoryQuerySchema =
  EntityHistoryListQuerySchema.extend({
    /** Restrict to one profile template (`ABOUT`, `OTHER_IDS`, …). */
    templateId: z.string().max(64).optional(),
  });

export type CompanyProfileHistoryQuery = z.infer<
  typeof CompanyProfileHistoryQuerySchema
>;

/** A `COMPANY_PROFILE` history entry, with its metadata typed. */
export const CompanyProfileHistoryEntrySchema = buildEntityHistoryEntrySchema(
  CompanyProfileHistoryMetadataSchema,
);

export type CompanyProfileHistoryEntry = z.infer<
  typeof CompanyProfileHistoryEntrySchema
>;

export const CompanyProfileHistoryResponseSchema =
  buildEntityHistoryListResponseSchema(CompanyProfileHistoryEntrySchema);

export type CompanyProfileHistoryResponse = z.infer<
  typeof CompanyProfileHistoryResponseSchema
>;
